<script setup>
import { ref, computed, watch, onMounted, useTemplateRef, getCurrentInstance } from 'vue'
import UserService from "@/services/UserService"
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { useNotification } from "@kyvg/vue3-notification"
import AlertModal from "@/components/modals/AlertModal.vue"
import ConfirmModal from '@/components/modals/ConfirmModal.vue'
import EditPhoneNumberModal from '@/components/modals/EditPhoneNumberModal.vue'
import Spinner from "@/components/ui/Spinner.vue"
import _ from 'lodash'
import FormButton from '../../components/Atoms/FormButton.vue'
import FormInput from '../../components/Atoms/FormInput.vue'
import IconBase from '../../components/icon/IconBase.vue'
import IconEdit from '../../components/icon/IconEdit.vue'
import IconBin from '../../components/icon/IconBin.vue'
import Alert from '../../components/Atoms/Alert.vue'
import { track, EVENTS } from '@/lib/tracking'

const instance = getCurrentInstance()
const root = instance.proxy.$root
const { notify } = useNotification()
const store = useStore()

// Refs
const error = ref(null)
const processing = ref(false)

const formErrors = ref({
  currentPassword: false,
  newPassword: false,
  newPasswordConfirm: false
})

const form = ref({
  currentPassword: null,
  newPassword: null,
  newPasswordConfirm: null
})

// Methods
const onInputChange = (prop) => {
  formErrors.value[prop] = false
}

const savePassword = async () => {
  error.value = null
  if (!validateForm()) return

  processing.value = true
  try {
    await UserService.changePassword(form.value)
    notify({ group: "success", title: "password reset successfully" })

    track(EVENTS.ACCOUNT_PASSWORD_CHANGED, {})

  } catch (err) {
    error.value = err
  }

  processing.value = false
}

const validateForm = () => {
  const props = ["currentPassword", "newPassword", "newPasswordConfirm"]

  let valids = 0
  _.each(props, prop => {
    const val = form.value[prop]
    if (val) valids++
    formErrors.value[prop] = !val
  })

  return valids === props.length
}

</script>

<template>
  <div class="view">
    <div class="flex flex-wrap w-full">
      <div class="w-full sm:w-5/12">
        <h1 class="page-title text-500 mb-4">Change Password</h1>
        <div class="flex flex-col gap-3 items-start">
          <!-- error placeholder -->
          <Alert v-if="error?.message" type="error">{{ error?.message }}</Alert>

          <FormInput label="Current Password" v-model="form.currentPassword" type="password"
            :isError="formErrors.currentPassword" placeholder="current password"
            @keypress="onInputChange('currentPassword')"
            :helper="formErrors.currentPassword ? 'specify current password' : null" />

          <FormInput label="New Password" v-model="form.newPassword" type="password" :isError="formErrors.newPassword"
            placeholder="current password" @keypress="onInputChange('newPassword')"
            :helper="formErrors.currentPassword ? 'specify new password' : null" />

          <FormInput label="Confirm New Password" v-model="form.newPasswordConfirm" type="password"
            :isError="formErrors.newPasswordConfirm" placeholder="current password"
            @keypress="onInputChange('newPasswordConfirm')"
            :helper="formErrors.newPasswordConfirm ? 'please confirm new password' : null" />

          <FormButton :disabled="processing" @click="savePassword">{{ processing ? 'Saving' : 'Save & Change' }}
          </FormButton>
        </div>
      </div>
    </div>
  </div>
</template>